import { arrayRemove } from '../util/jsTools';

// types
//-----------------------------------------------------------------------------
type Listener<DATA> = (data?: DATA) => boolean | void;

/*
    simple observer
*/
export default class Observer<DATA = void> {
  // fields
  //-------------------------------------------------------------------------
  private _listeners: Listener<DATA>[] = [];

  // api
  //-------------------------------------------------------------------------
  public publish(data: DATA): boolean {
    let handled = false;

    // notify listeners in reverse (allows mid loop removal)
    for (let i = this._listeners.length; i--;) {
      if (this._listeners[i](data)) {
        handled = true;
      }
    }

    return handled;
  }

  public subscribe(listener: Listener<DATA>) {
    // add listener
    this._listeners.push(listener);
  }

  public unsubscribe(listener: Listener<DATA>) {
    // remove listener
    arrayRemove(this._listeners, listener);
  }

  public unsubscribeAll() {
    this._listeners = [];
  }
}
